import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React from "react";
import TopHeadlineCard from "./TopHeadlineCard";
import stylesgfi from "../pages/ESportLinks/ESportLinks.module.css";

const cards = [
  {
    id: 24,
    title: "India vs New Zealand Under 20 Rugby Series 2026",
    text: "To mark 100 years of friendship between India and New Zealand, the India vs New Zealand Under 20 Rugby Series will be held from 23 to 28 October 2026 at the State Sports Academy in Rajgir, Bihar. The main matches of the series will take place on 27 October. The event will feature matches between the under 20 boys' and girls' teams of both countries, along with mixed team matches. Through this series, the New Zealand under 20 rugby team will play on Indian soil for the first time.",
    image: "https://biharsports.org/img/ind-nz-u20-rugby/tab.png",
    // image: false,
    url: "#",
  },
  {
    id: 23,
    title: "Bihar State Open eSports Championship Begins",
    text: "The 3rd Bihar State Open eSports Championship commenced on 4 May 2026 with 2,182 participants across BGMI, Chess, eFootball Mobile, FC26 and Street Fighter 6. The LAN Grand Finale will be held on 16 May 2026 at Indoor Stadium, Pataliputra Sports Complex, Patna.",
    image: "https://biharsports.org/img/esports-2026-home.png",
    // image: false,
    url: "/esports2026",
  },
  {
    id: 22,
    title: "Senior National Rugby 7s Championship 2026",
    text: "Teams from across the country will participate in the Senior National Rugby 7s Championship 2026. This competition will be held from April 16 to 21 at the State Sports Complex in Rajgir, Bihar. The event will commence with the women's teams, with 27 teams competing on April 16 and 17. Subsequently, 26 teams will compete in the men's category on April 20 and 21.",
    image: "https://biharsports.org/img/sen-nat-rug-7-home.jpeg",
    // image: false,
    url: "https://biharsports.org/senior-national-rugby-7s-2026",
    // url: "#",
  },
  {
    id: 21,
    title: "16th Hockey India Sub-Junior Men's National Championship 2026",
    text: "The 16th Hockey India Sub-Junior Men's National Championship 2026 is being organized at the Rajgir Hockey Stadium in Rajgir, Bihar. 30 teams from across the country (representing States and Union Territories) will participate in this tournament. The competition will be held from April 1 to April 12, 2026.",
    image: "https://biharsports.org/img/sub-jun-hock-16-home.png",
    // image: false,
    url: "https://biharsports.org/sub-junior-mens-hockey-2026",
    // url: "#",
  },
  {
    id: 20,
    title: "2nd Bihar Women's Kabaddi League, 2026",
    text: "The 2nd Bihar Women's Kabaddi League, organized by the Bihar State Sports Authority, is scheduled to take place from March 11 to March 17, 2026, at the Pataliputra Sports Complex (Indoor Stadium) in Patna, with six teams participating: Sitamarhi Sentinels, Magadh Warriors, Saran Strikers, Patna Pelicans, Nalanda Ninjas, and Siwan Titans.",
    image: "https://biharsports.org/img/BWKLE2-Home.jpeg",
    // image: false,
    url: "https://biharsports.org/bihar-Women-Kabaddi-League-Edition-2",
    // url: "#",
  },
  {
    id: 19,
    title: "Men's Asia Hockey Cup 2025",
    // content to be updated
    text: "Bihar is set to host the Hero Asia Cup 2025 for the very first time. This will be the 12th edition of the prestigious men’s hockey championship, bringing together top teams from India, China, Japan, Chinese Taipei, Malaysia, Korea and Oman.",
    // image to be updated
    // image: "/img/HeroMensHockeyAsiaCup2025Rajgir/homeBanner.jpg",
    image: "https://biharsports.org/img/model-code-conduct/HeroMensHockeyAsiaCup2025Rajgir/homeBanner.jpg",
    // image: false,
    url: "/hero-asia-cup-2025",
    // url: "#",
  },
  {
    id: 18,
    title: "Asia Rugby U20 7s Championship 2025",
    // content to be updated
    text: "A golden chapter is about to be written in the history of Bihar! For the first time ever, the ancient city of Rajgir will proudly host the prestigious Asia Rugby U20 Sevens Championship 2025 on 9th and 10th August",
    // image to be updated
    // image: "/img/AsiaRugbyU207s/homeBanner.jpg",
    image: "https://biharsports.org/img/model-code-conduct/AsiaRugbyU207s/homeBanner.jpg",
    // image: false,
    url: "/asia-rugby-u20-7s",
    // url: "#",
  },
  {
    id: 17,
    title: "Khelo India Youth Games 2025",
    // content to be updated
    text: "Khelo India Youth Games 2025 will be organized in five districts of Bihar this time, which include Patna, Gaya, Nalanda (Rajgir), Bhagalpur and Begusarai. This game will be organized from May 4 to May 15. Along with this, competitions of gymnastics, track cycling and shooting will also be organized in Delhi, which will provide a great platform to the players.",
    // image to be updated
    // image: "img/kiyg25.jpg",
    image: false,
    url: "khelo-india-youth-games-2025",
    // url: "#",
  },
  {
    id: 16,
    title: "ISTAF Sepaktakraw World Cup 2025 Bihar",
    text: "The ISTAF Sepaktakraw World Cup will be held from March 20 to 25 at the Pataliputra Sports Complex in Bihar. In this competition, the best Sepaktakraw players from 20 countries will showcase their skills.",
    image: "img/istaf-sepak-takraw.jpg",
    url: "istaf-sepaktakraw-page-2025",
    // url can be changed later
  },
  {
    id: 15,
    title: "The 38th National Games Uttarakhand 2025",
    text: "In the 38th National Games 2025 held in Uttarakhand, the players of Bihar performed brilliantly and won 1 gold, 6 silver and 5 bronze medals. This victory is the result of their hard work, dedication and unwavering passion.",
    image: "img/uttarakhand 38th national games 432x231.jpg",
    url: "38thnationalgames",
  },
  {
    id: 13,
    title: "The 68th National School Games Rugby 2024-25",
    text: "The 68th National School Games Rugby 7s Boys and Girls competition is being held at Patliputra Sports Complex, Kankarbagh. The Under-19 (boys and girls) competition will be held from December 24-25, Under-17 (boys and girls) from December 28-29, and Under-14 (boys and girls) from January 1-2. The event will provide an opportunity to players of different age groups to showcase their talent.",
    // image: "img/nationalSchoolGame24-25.jpg",
    image: false,
    url: "/",
  },
  {
    id: 12,
    title: "Second Wrestling Competition",
    text: "The second wrestling competition of Bihar's traditional wrestling is being organized on 25 and 26 December 2024 at Mansoorchak, N.N. Sinha High School, Bachhwara, Begusarai. This competition is being organized by the Sports Department and Bihar State Sports Authority. A cash prize of total Rs 12.5 lakhs will be given in this competition. The first prize is Rs 1 lakh, second prize is Rs 75 thousand and third prize is Rs 25 thousand. The best player will be given a silver mace.",
    image: "img/SecondWrestlingCompetition.jpg",
    url: "/",
  },
  {
    id: 11,
    title: "Mashaal",
    text: "The country's largest sports talents hunt competition - Mashaal is going to be held for the first time in Bihar. There will be competition in athletics, cycling, football, kabaddi and volleyball. This competition will be organized at school, cluster, block, district and state level. In this, the students selected at the state level will be given a scholarship of up to Rs 3 lakh under the Prerna Scholarship Scheme. The winning students will be given medals, cash as well as certificates.",
    image: "img/Mashal icon.jpg",
    url: "/",
  },
  {
    id: 10,
    title: "32nd National Junior Fencing Championship 2024-25",
    text: "For the first time in Bihar, the 32nd National Junior Fencing Championship 2024-25 has been organized by the Sports Department and Bihar State Sports Authority. It has been organized from 2 to 5 December in the Indoor Hall of Patliputra Sports Complex. It included more than 800 under 20 players from 29 states and Union Territories.",
    image: "img/Fencing icon.jpg",
    url: "/",
  },
  {
    id: 9,
    title: "Bihar Women's Asian Champions Trophy 2024",
    text: 'Bihar is hosting the "Bihar Women\'s Asian Champions Trophy 2024" for the year 2024 from 11 - 20 November. The tournament is named "Hockey Ka Parv, Bihar Ka Garv", in which six Asian teams from India, Malaysia, China, Korea, Japan and Indonesia are competing.',
    image: "img/ACTHome.jpeg",
    url: "/",
  },

  {
    id: 8,
    title: "First Bihar Volleyball League 2024",
    text: "The first Bihar Volleyball League is going to be organized by Bihar State Sports Authority from 8 to 15 September 2024 at Patliputra Sports Complex, Indoor Stadium, Patna in which 6 teams (Patliputra Acers, Mithila Spikers, Vikramshila Blockers, Magadh Setters, Takshashila Servers and Nalanda Defenders) are participating.",
    image: "img/VallyballFlogo.jpeg",
    url: "/",
  },
  // {
  //   id: 7,
  //   title: "Rajgir Sports University and Sports Academy inauguration",
  //   text: "Rajgir Sports University and Sports Academy was inaugurated by Shri Nitish Kumar, Hon'ble Chief Minister, Bihar on 29 August 2024. It is the first sports university of Bihar. Facilities like hockey turf, swimming pool, football ground, cricket stadium, and indoor stadium have been built in this campus. An exhibition match was also organized on the occasion of inauguration, in which the Indian women's hockey team participated.",
  //   image: "img/Webpage Logo.jpg",
  //   url: "/",
  // },
  {
    id: 6,
    title: "India in Paris Olympic Games 2024 ",
    text: "Paris Olympic Games 2024 is being organized from 26 July 2024 to 11 August 2024. India will participate in Paris Olympics 2024 with 117 athletes, including 70 men and 47 women, in 16 sports disciplines. They will participate in 69 events for 95 medals. Click here for detailed information on the current status of medals by India in Paris Olympics 2024, sports schedule and results.",
    image: "img/parisOlampic.jpeg",
    url: "/",
  },
  // {
  //   id: 5,
  //   title: "ESPORTS Competition 2023",
  //   text: "For the first time in Bihar, an ESPORTS competition has been organized by Bihar State Sports Authority from 16th December to 22nd December 2023 at Patliputra Sports Complex, Kankarbagh, Patna. The grand finale of this competition has been scheduled on 28th December 2023 at Patliputra Sports Complex itself. Under this competition, players can register themselves for 4 different online games.",
  //   image: "img/E_Sports_fh.jpg",
  //   url: "/eSportLinks",
  // },
  // {
  //   id: 4,
  //   title: "The 10th season of Pro Kabaddi League- 2023-24",
  //   text: "The 10th season of Pro Kabaddi League is being organized from 2nd December 2023 to 21st February 2024. This year, Bihar State Sports Authority is sponsoring the team 'Patna Pirates'.",
  //   image: "img/ProCbaddi.jpg",
  //   url: "/prokabaddi",
  // },
  // {
  //   id: 3,
  //   title: "Chess Championship 2024",
  //   text: "Chess Championship is being organized by Bihar State Sports Authority from 5th February 2024 to 10th February 2024.",
  //   image: "img/Chessss.jpg",
  //   url: "#",
  // },
  // {
  //   id: 1,
  //   title: "67th National School Games 2023",
  //   text: "The 67th National School Games 2023 is being organized in Bihar by the School Games Federation of India in 05 sports disciplines – Athletics, Cricket, Sepak Takraw, Weightlifting and Football.",
  //   image: "img/sixty_seventh_sgfi.jpg",
  //   url: "/national-school-games",
  // },
  // {
  //   id: 2,
  //   title: "National Games - 2023",
  //   text: "The National Games is being organized from 25 October to 09 November 2023. Many legendary players who have made India proud on the world stage have participated in this competition. The first National Games was organized in the year 1924 in Lahore city of undivided India. While 36 different sports disciplines were included in the National Games in the year 2022, this time the number of sports disciplines has increased to 43.    ",
  //   image: "img/national-games.jpeg",
  //   url: "/nationalgames",
  // },
];

const NewTopHeadline = () => {
  return (
    <div
      className="container"
      style={{
        borderRadius: "8px",
        marginTop: "15px",
        marginBottom: "5px",
      }}
    >
      <Tabs isManual variant="enclosed">
        <TabList style={{ overflowX: "auto" }}>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            India vs New Zealand Under 20 Rugby Series 2026
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Bihar State Open eSports Championship
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Senior National Rugby 7s Championship 2026
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            16th Sub-Junior Men’s Nationals 2026  
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Bihar Women's Kabaddi League 2026
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Men's Asia Hockey Cup 2025
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Asia Rugby U20 7s Championship 2025
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Khelo India Youth Games 2025
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            ISTAF Sepaktakraw World Cup 2025 Bihar
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            The 38th National Games Uttakakhand 2025
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            The 68th National School Games Rugby 2024-25
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Second Wrestling Competition
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Mashaal
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            32nd National Junior Fencing Championship 2024-25
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Bihar Women's Asian Champions Trophy 2024
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            First Bihar Volleyball League 2024
          </Tab>
          {/* <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Rajgir Sports University and Sports Academy inauguration
          </Tab> */}
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            India in Paris Olympic Games 2024
          </Tab>
          {/* <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            ESPORTS Competition 2023
          </Tab>
          <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            The 10th season of Pro Kabaddi League
          </Tab> */}
          {/* <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            Chess Championship 2024
          </Tab> */}
          {/* <Tab className={`${stylesgfi.text_tab}`} fontSize="2xl" as="b">
            67th National School Games 2023
          </Tab> */}
          {/* <Tab fontSize="2xl" as="b">
            National Games - 2023
          </Tab> */}
        </TabList>
        <TabPanels
          style={{
            borderLeft: "1px solid #cfd9de",
            borderRight: "1px solid #cfd9de",
            borderBottom: "1px solid #cfd9de",
            borderRadius: "0px 0px 5px 5px",
          }}
        >
          {/* initially mounted */}

          {cards.map((card, index) => (
            <TabPanel key={index}>
              <TopHeadlineCard card={card} />
            </TabPanel>
          ))}

          {/* <TabPanel>
            <p>one!</p>
          </TabPanel>
          initially not mounted
          <TabPanel>
            <p>two!</p>
          </TabPanel> */}
        </TabPanels>
      </Tabs>
    </div>
  );
};

export default NewTopHeadline;
